(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["artistes-similaires"] && !Shopify.designMode) return;
  try {
    // Le défilement lui-même est natif : tactile et molette marchent sans nous.
  // Ce script ne sert qu'aux flèches, et il ne les montre que si la piste
  // déborde vraiment — à six artistes sur un grand écran tout tient, et deux
  // boutons inertes ne feraient que du bruit.
  (function () {
    function equiper(bloc) {
      if (bloc.dataset.lmsPret) return;
      bloc.dataset.lmsPret = '1';

      // En habillage rond la piste est une grille : rien à faire défiler, et
      // un ResizeObserver de plus sur chaque fiche produit ne sert à rien.
      if (bloc.classList.contains('lms-voisins--ronds')) return;

      var piste = bloc.querySelector('.lms-voisins__piste');
      var barre = bloc.querySelector('.lms-voisins__fleches');
      if (!piste || !barre) return;

      var boutons = barre.querySelectorAll('.lms-voisins__fleche');

      function rafraichir() {
        var deborde = piste.scrollWidth - piste.clientWidth > 4;
        barre.hidden = !deborde;
        if (!deborde) return;
        var fin = piste.scrollWidth - piste.clientWidth - piste.scrollLeft <= 4;
        boutons.forEach(function (b) {
          b.disabled = b.dataset.sens === '1' ? fin : piste.scrollLeft <= 4;
        });
      }

      boutons.forEach(function (b) {
        b.addEventListener('click', function () {
          // On avance d'une carte pleine plus sa gouttière, pour ne jamais
          // laisser une carte coupée en bord de piste.
          var carte = piste.querySelector('.lms-voisins__case');
          var pas = carte ? carte.getBoundingClientRect().width + 16 : 200;
          piste.scrollBy({ left: pas * Number(b.dataset.sens), behavior: 'smooth' });
        });
      });

      piste.addEventListener('scroll', rafraichir, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(rafraichir).observe(piste);
      rafraichir();
    }

    function tout() {
      document.querySelectorAll('.lms-voisins').forEach(equiper);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tout);
    } else {
      tout();
    }
    // Le sélecteur de variante re-rend la section en Liquid : le bloc revient
    // neuf et doit être ré-équipé.
    document.addEventListener('shopify:section:load', tout);
  })();
  } catch(e) { console.error(e); }
})();

})();
